import subscription from '../../helpers/subscription';
export const setLockedFlag = (vod) => {
    const vodItemPackages = vod.subscriptionGuids ?? null;
    let isLocked = false;

    if (
        vodItemPackages !== null &&
        subscription.checkItemBelongsToAddonsPackages(vodItemPackages) &&
        !subscription.checkItemBelongsToActivePackages(vodItemPackages)
    ) {
        isLocked = true;
    }

    return { ...vod, isLocked };
};

export const getStreamingUrlByAssetType = (data, assetTypes) => {
    const foundItem = data?.find(
        (item) => item?.assetTypes && item?.assetTypes.some((type) => assetTypes?.includes(type))
    );

    return foundItem ? foundItem.streamingUrl : null;
};
